import { useParams } from 'react-router-dom'

import { ItemDetailPageDocument } from 'generated/resources/graphql'
import compact from 'lodash/compact'

import { useMemo } from 'modules/core/hooks/useMemo'
import { useQuery } from 'modules/core/hooks/useQuery'

import TaskElement from 'modules/tasks/components/TaskElement'
import { TaskIdentifier } from 'modules/tasks/lib/task'

import { useMaterializedProcessContext } from '../MaterializedProcessPage'

const ItemDetailPage = () => {
  const { materializedItemId } = useParams()

  const { materializedProcess } = useMaterializedProcessContext()

  const materializedItem = useMemo(() => {
    if (!materializedItemId || !materializedProcess) return

    return materializedProcess.materializedSteps
      .flatMap((step) => step.materializedItems)
      .find((item) => item.id === Number(materializedItemId))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [materializedItemId])

  const { data, loading } = useQuery(ItemDetailPageDocument, {
    variables: {
      taskId: Number(materializedItem?.resourceId),
      usageGroupSlugs: ['employees-questions'],
    },
  })

  const customResourceFieldsData =
    compact(data?.customFields.resourceFieldsConnection.edges.map((edge) => edge.node)) ?? []

  const customValuesData =
    data?.tasks.tasksConnection.edges[0]?.node?.affecteesConnection.edges[0]?.node?.employee?.valuesConnection.edges.map(
      (edge) => edge.node
    ) ?? []

  const canEmployeeManageAnyEmployeeFolder =
    data?.documents._policies.employeeManageAnyEmployeeFolder.can ?? false

  return (
    <TaskElement
      identifier={TaskIdentifier.Workflow}
      taskId={Number(materializedItem?.resourceId)}
      canEmployeeManageAnyEmployeeFolder={canEmployeeManageAnyEmployeeFolder}
      loading={loading}
      customResourceFieldsData={customResourceFieldsData}
      customValuesData={customValuesData}
    />
  )
}

export default ItemDetailPage
